var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.emblemId)?_c('cld-image',{staticClass:"d-inline-flex align-middle cld-hidpi",attrs:{"public-id":_vm.publicId,"width":_vm.size,"dpr":"3.0","crop":"fill"}},[(_vm.shadow)?_c('cld-transformation',{attrs:{"effect":"shadow:0","x":"1","y":"1"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }